import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isConnected: false,
  account: null,
  ethereum: null,
  profile: null,
  wallet: null,
  reconnectionError: null,
};

export const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setConnect: (state, action) => {
      state.account = action.payload.account;
      state.wallet = action.payload.wallet;
      state.isConnected = true;
      state.isReconnecting = false;
      state.reconnectionError = null;
    },
    setEthereum: (state, action) => {
      state.ethereum = action.payload;
    },
    setDisconnect: (state, action) => {
      state.account = null;
      state.isConnected = false;
      state.wallet = null;
      state.isReconnecting = false;
      state.reconnectionError = null;
    },
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    setReconnecting: (state, action) => {
      state.isReconnecting = action.payload;
    },
    setReconnectionError: (state, action) => {
      state.reconnectionError = action.payload;
      state.isReconnecting = false;
    },
    clearReconnectionError: (state) => {
      state.reconnectionError = null;
    },
  },
});

export const { 
  setConnect, 
  setDisconnect, 
  setProfile, 
  setEthereum,
  setReconnecting,
  setReconnectionError,
  clearReconnectionError
} = AuthSlice.actions;

export default AuthSlice.reducer;
